import React from 'react';
import PropTypes from 'prop-types';
import { cache } from 'swr';

import AuthLayout from 'components/AuthLayout';
import GenericLayout from 'components/GenericLayout';
import OnboardingLayout from 'components/OnboardingLayout';
import DashboardLayout from 'components/DashboardLayout';
import ResidentsPropertyPageLayout from 'components/ResidentsPropertyLayout';

import { AuthApi } from 'services/api';
import { Router } from 'utils/with-i18next';
import {useUser} from 'contexts/UserContext';
import isUserAuthorize from 'utils/isUserAuthorize';
import { ContextProvider } from 'contexts/LayoutDashboardContext';
import { Loader ,Alert} from 'rsuite';
import {createErrorStatusCodeHandler}  from 'utils/default-http-error-handler';


export const Layouts = {
  AUTH: 'auth',
  ONBOARDING: 'onboarding',
  DASHBOARD: 'dashboard',
  GENERIC: 'generic',
  RESIDENTS: 'residents',
};

export function Layout({ children, type, pageId, image, byPassAuth }) {
  /**
   * check router history
   * if(router history > 1)
   */

  const redirectTo = Layouts.AUTH === type ? '/dashboard/bookings' : '/login';
  const redirectIfFound = Layouts.AUTH === type ? true : false;

  const { user , clearUser} = useUser({
    ...(!byPassAuth && { redirectTo, redirectIfFound }),
  });

  const handleLogout = () => {
    AuthApi.logout().then(() => {
      cache.clear();
      clearUser();
      Router.push('/login');
    }).catch(createErrorStatusCodeHandler("logout"));
  };

  switch (type) {
    case Layouts.AUTH:
      return <AuthLayout>{children}</AuthLayout>;
    case Layouts.DASHBOARD:
      return isUserAuthorize(user) ? (
        <ContextProvider>
          <DashboardLayout pageId={pageId} currentUser={user} handleLogout={handleLogout}>
            {children}
          </DashboardLayout>
        </ContextProvider>
      ) : (
        <Loader content="loading..." center />
      );
    case Layouts.ONBOARDING:
      return (
        <OnboardingLayout image={image} currentUser={user} handleLogout={handleLogout}>
          {children}
        </OnboardingLayout>
      );
    case Layouts.RESIDENTS:
      return (
        <ResidentsPropertyPageLayout image={image} currentUser={user} handleLogout={handleLogout}>
          {children}
        </ResidentsPropertyPageLayout>
      );
    default:
      return (
        <GenericLayout handleLogout={handleLogout} currentUser={user}>
          {children}
        </GenericLayout>
      );
  }
}

Layout.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(Object.values(Layouts)),
  pageId: PropTypes.string,
  image: PropTypes.string,
};

export default Layout;
